import { render, staticRenderFns } from "./companyIntro.vue?vue&type=template&id=2ebd6b82&scoped=true"
import script from "./companyIntro.vue?vue&type=script&lang=js"
export * from "./companyIntro.vue?vue&type=script&lang=js"
import style0 from "./companyIntro.vue?vue&type=style&index=0&id=2ebd6b82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd6b82",
  null
  
)

export default component.exports